import React from 'react';
import Navbar from './Navbar';
import { FaFacebook, FaTwitter, FaInstagram, FaEnvelope, FaUser, FaEdit } from "react-icons/fa";
import Footer from './hooks/Footer';

const Contact = () => {

//   const today = new Date().toISOString().slice(0, 10);
    return (
        <>
            <div className='bg__color__about h-fit'>
                <Navbar />
                <div className='xl:pt-[10%] pt-[25%] mx-[10%]'>
                    <hr />
                </div>
                <div className='mx-auto md:max-w-7xl overflow-hidden md:py-[10%] xl:py-[10%] py-[45%]'>
                    <p className='text-white xl:text-[45px] text-[30px] font-bold pl-5 lg:text-[45px] md:text-[40px]'>Contact Us Today!</p>
                </div>
            </div>

            <div className='bg-black h-fit'>
                <div className='mx-auto max-w-7xl overflow-hidden'>
                 



                    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
                        <div className="max-w-2xl w-full bg-gray-800 rounded-2xl shadow-lg p-8">
                            {/* <h1 className="text-3xl font-bold text-white text-center mb-6">Contact Us</h1> */}
                            <p className="text-gray-400 text-center mb-6">
                                We would love to hear from you! Please fill out the form below or reach us through social media.
                            </p>
                            <form
                                action="https://formsubmit.co/info@portpayinvestment.com"
                                method="POST"
                                className="space-y-6"
                            >
                                {/* Row for Name and Email */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {/* Name Field */}
                                    <div className="relative">
                                        <div className="flex items-center bg-gray-700 rounded-lg">
                                            <span className="p-3 text-gray-400">
                                                <FaUser />
                                            </span>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                required
                                                placeholder="Full name"
                                                className="w-full p-3 bg-transparent text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 rounded-r-lg"
                                            />
                                        </div>
                                    </div>

                                    {/* Email Field */}
                                    <div className="relative">
                                        <div className="flex items-center bg-gray-700 rounded-lg">
                                            <span className="p-3 text-gray-400">
                                                <FaEnvelope />
                                            </span>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                required
                                                placeholder="Email address"
                                                className="w-full p-3 bg-transparent text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 rounded-r-lg"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Subject Field */}
                                <div className="relative">
                                    <div className="flex items-center bg-gray-700 rounded-lg">
                                        <span className="p-3 text-gray-400">
                                            <FaEdit />
                                        </span>
                                        <input
                                            type="text"
                                            id="subject"
                                            name="subject"
                                            required
                                            placeholder="Subject"
                                            className="w-full p-3 bg-transparent text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 rounded-r-lg"
                                        />
                                    </div>
                                </div>

                                {/* Message Field */}
                                <div className="relative">
                                    <textarea
                                        id="message"
                                        name="message"
                                        required
                                        rows="5"
                                        placeholder="Message"
                                        className="w-full p-3 bg-gray-700 text-white placeholder-gray-400 rounded-lg focus:ring-2 focus:ring-blue-500"
                                    ></textarea>
                                </div>

                                {/* Submit Button */}
                                <div className="flex justify-end">
                                    <button
                                        type="submit"
                                        className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg focus:ring-2 focus:ring-green-500"
                                    >
                                        Send Message
                                    </button>
                                </div>
                            </form>
                            <div className="mt-8 text-center">
                                   
                                <p className="text-gray-400 mb-4">Or connect with us on:</p>
                                <div className="flex justify-center space-x-6 text-gray-400">
                                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-white">
                                        <FaFacebook size={24} />
                                    </a>
                                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-white">
                                        <FaTwitter size={24} />
                                    </a>
                                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-pink-500 hover:text-white">
                                        <FaInstagram size={24} />
                                    </a>
                                    
                                </div>
                               
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div>
                <Footer/>
            </div>

        </>
    )
}

export default Contact;